import {
  CalendarIcon,
  ChartBarIcon,
  CogIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/outline'

import { ENABLE_ARCHIVED_GAMES } from '../../constants/settings'
import { GAME_TITLE } from '../../constants/strings'
import { solutionIndex } from '../../lib/words'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsDatePickerModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsDatePickerModalOpen,
  setIsSettingsModalOpen,
}: Props) => {
  return (
    <nav className="w-full border-b border-slate-300 p-2 dark:border-slate-600">
      <div className="mx-auto flex w-full max-w-xl items-center justify-between">
        <div className="flex select-none items-center">
          <h1
            className="block rounded-lg bg-indigo-100 px-3 py-1 text-2xl font-bold italic tracking-wide text-indigo-600 dark:bg-indigo-600 dark:text-slate-100"
            onClick={() => window.location.reload()}
          >
            {GAME_TITLE}
          </h1>
          <h2 className="ml-3 text-lg font-bold italic tracking-wide text-slate-600 dark:text-slate-400">
            #{solutionIndex + 1}
          </h2>
        </div>
        <div className="flex items-center justify-end">
          <QuestionMarkCircleIcon
            className="mr-2 h-7 w-7 cursor-pointer dark:stroke-white"
            onClick={() => setIsInfoModalOpen(true)}
          />
          <ChartBarIcon
            className="mr-2 h-7 w-7 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
          {ENABLE_ARCHIVED_GAMES && (
            <CalendarIcon
              className="mr-2 h-7 w-7 cursor-pointer dark:stroke-white"
              onClick={() => setIsDatePickerModalOpen(true)}
            />
          )}
          <CogIcon
            className="h-7 w-7 cursor-pointer dark:stroke-white"
            onClick={() => setIsSettingsModalOpen(true)}
          />
        </div>
      </div>
    </nav>
  )
}
